if ( typeof window.glob !== 'object' ) {
	const glob = { prop: { registered: {}, status: {} } };
	glob.prop.uri = { server: window.location.protocol + "//" + (String(window.location.port) === "3000" ? "infocontenuti.lan.crossbow.it" : window.location.host) + "/" };
	glob.prop.uri.site = glob.prop.uri.server + "ic/prenotazioni/";
	glob.prop.uri.api = glob.prop.uri.site + 'api/';
	glob.prop.uri.auth = glob.prop.uri.site + 'auth/';
	glob.prop.uri.web = glob.prop.uri.site + 'web/';
	glob.prop.appRootNode = document.getElementById("appRootNode");
	glob.prop.traffic = { sent: 0, calls: 0, errors: 0, inerror : 0, pending: 0 };

	glob.generateUid = ()=>{
		return ("10000000-1048-4000-8000-1400800110084").replace(/[018]/g, c =>
			(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
		);
	};

	glob.register = ( contexts, trigger, uid ) => {
		if ( typeof contexts === 'string' ) contexts = [contexts];
		if ( typeof trigger !== 'function' ) {
			glob.unregister(contexts,uid);
			return;
		}
		if ( typeof uid !== 'string' ) uid = glob.generateUid();
		if ( Array.isArray(contexts) ) contexts.forEach( c => {
			try {
				if ( typeof glob.prop.registered[c] === 'undefined') glob.prop.registered[c] = {};
				glob.prop.registered[c][uid] = trigger;
			} catch(e) {
				console.log("glob.register", e, contexts, uid, trigger );
			}
		});
		return ()=>{ glob.unregister(contexts, uid); };
	};
	glob.unregister = ( contexts, uid ) => {
		if ( typeof uid !== 'string' ) return;
		if ( typeof contexts === 'string' ) contexts = [contexts];
		if ( Array.isArray(contexts) ) contexts.forEach( c => {
			try {
				if ( typeof glob.prop.registered[c] === 'object') delete glob.prop.registered[c][uid];
			} catch(e) {
				console.log("glob.unregister", e, uid, contexts );
			}
		});
	};
	glob.trigger = async ( context, ...args ) => {
		if ( typeof context !== 'string' ) return;
		// console.log(context,args,glob.prop.registered[context]);
		if ( glob.prop.registered[context] ) Object.entries(glob.prop.registered[context]).forEach(([uid,trigger])=>{
			if ( typeof trigger === 'function' ) setTimeout( ()=>{ trigger.apply(undefined, args); }, 10);
		});
	};
	glob.getStatus = ( s ) => { return glob.prop.status[s]; };
	glob.setStatus = ( s, v, data, data2 ) => {
		glob.prop.status[s] = v;
		glob.trigger( s, v, data, data2 );
	};
	glob.dropStatus = ( s, broadcast ) => {
		if ( typeof s === "string" ) s = [s];
		if ( ! Array.isArray(s) ) return;
		s.forEach( x =>{
			delete glob.prop.status[x];
			if ( broadcast ) glob.trigger(x);
			delete glob.prop.registered[x];
		})
	};

	glob.appStatus = () => {
		const curclass = glob.prop.appRootNode.className;
		let newclass = "";
		if ( glob.prop.traffic.pending ) {
			switch ( curclass ) {
				case "error" : newclass = "warning"; break;
				case "warming" : newclass = "warning"; break;
				default : newclass = "success";
			}
		} else if ( glob.prop.traffic.inerror ) {
			glob.prop.traffic.inerror = 0;
			newclass = "error";
		}
		if ( newclass || curclass ) {
			if ( glob.prop.traffic.to ) clearTimeout( glob.prop.traffic.to );
			glob.prop.traffic.to = setTimeout(()=>{
				delete glob.prop.traffic.to;
				glob.appStatus();
			}, 250);
		}
		if ( newclass || glob.prop.traffic.to ) {
			glob.prop.appRootNode.className = newclass;
		}
		return newclass;
	};

	glob.loginSucceded = ( mail, session ) => {
		const ldata = {
			name : mail.replace(/@.+/,""),
			mail : mail,
			session: session
		};
		glob.appStatus();
		if ( glob.storage ) {
			glob.storage.local.setItem('prenotazioniLastEmail',mail);
			glob.storage.session.setItem('prenotazioniSession',session);
		}
		glob.prop.status.loggedIn = true;
		glob.setStatus('login', ldata );
		glob.setStatus('loggedIn',true);
	};

	glob.logout = ( confirmed ) => {
		if ( ! confirmed) {
			if ( window.confirm("Effettuare il logout?") ) {
				setTimeout( ()=>{ glob.logout(true) },100);
			}
			return;
		}
		glob.api('logout').finally( () => {
			if ( glob.storage ) glob.storage.session.removeItem('prenotazioniSession');
			glob.logoutSucceded();
		});
	};

	glob.logoutSucceded = () => {
		glob.prop.status.loggedIn = false;
		glob.setStatus('login', {} );
		glob.setStatus('loggedIn',false);
	};

	glob.api = ( act, data={}) => {
		const bd = JSON.stringify(data);
		glob.prop.traffic.calls++;
		glob.prop.traffic.pending++;
		glob.prop.traffic.sent += bd.length;
		glob.appStatus();
		return new Promise( (resolve, reject) => {
			window.fetch(
				glob.getUri('api'),
				{
					method: 'POST',
					cache: 'no-cache',
					headers: {
						'X-api-request': true,
						'X-api-email': glob.prop.status.login.mail,
						'X-api-session': glob.prop.status.login.session,
						'X-api-action': act,
						'pragma': 'no-cache',
						'cache-control': 'no-cache',
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					},
					referrerPolicy: 'no-referrer',
					body: bd
				}
			).then( response => {
				if ( ! response.ok ) throw response;
				return response.json();
			}).then( jdata => {
				glob.appStatus();
				resolve(jdata);
			}).catch( e => {
				if ( e && typeof e === 'object' && e.status === 403 ) {
					if ( glob.storage ) glob.storage.session.removeItem('prenotazioniSession');
					e.message = "La sessione è scaduta";
					setTimeout( ()=>{ window.location.reload();}, 100 );
				} else {
					glob.prop.traffic.errors++;
					glob.prop.traffic.inerror++;
					glob.appStatus();
				}
				reject( e );
			}).finally( ()=>{
				glob.prop.traffic.pending--;
			});
		})
	}

	glob.getUri = ( c ) => { return glob.prop.uri[c] + glob.generateUid().replace(/-/g,"") };

	glob.slot = {
		prop : {},
		reset: () => { glob.slot.prop = {} },
		full: async (k) => {
			if ( k?.slot ) k = k.slot;
			if ( k?.kslot ) k = k?.kslot;
			if ( k?.kslotprenotazione ) k = k?.kslotprenotazione;
			if ( ! k ) return undefined;
			if ( typeof glob.slot.prop[k] === "undefined" ) glob.slot.prop[k] = await glob.api( 'listPrenotazioniBySlot', { kslot: k });
			return JSON.parse(JSON.stringify(glob.slot.prop[k]));
		},
		get: async (k) => {
			if ( ! k ) return undefined;
			const s = await glob.slot.full(k);
			return s?.slot;
		},
		data: async (k) => {
			if ( ! k ) return undefined;
			const s = await glob.slot.full(k);
			return s?.data;
		},
		conflitti: async ( slot, preno, newdata ) => {
			delete glob.slot.prop.conflitto;
			if (! ((newdata?.timeStart?.length && newdata?.timeEnd?.length && newdata?.date?.length)||(preno?.tinizio?.length && preno?.tfine?.length)) ) return [];
			const date = newdata?.date ?? preno.tinizio.replace(/ .*/,"");
			const data = await glob.slot.data(slot)||[];
			const currentEmail = glob.getStatus('login')?.mail;
			const annodicorso =  preno?.lofanno ?? preno?.lannocorso ?? preno?.of?.lannocorso ?? "";
			const lente = preno?.ente?.lente ?? preno?.lente;
			const sd = data.filter( p => {
				if ( ! p?.tinizio ) return false;
				if ( ! p.tinizio.startsWith(date) ) return false;
				if ( p.email === currentEmail) return false;
				if ( p.lofanno !== annodicorso ) return false;
				if (p?.lente !== lente ) return false;
				//if (p?.lcanale !== preno?.lcanale ) return false; // Non lo controlliamo perché il canale è gestito AC/DC
				return true;
			});
			if ( ! sd.length ) return [];
			const timeStart = newdata?.timeStart ?? preno.tinizio.replace(/^.* (..:..).*$/,"$1");
			const timeEnd = newdata?.timeEnd ?? preno.tfine.replace(/^.* (..:..).*$/,"$1");
			const ts = date + ' ' + timeStart + ':00';
			const te = date + ' ' + timeEnd + ':00';
			const conflitti = sd.filter( p => ( p.tinizio < te && p.tfine > ts ) );
			if (conflitti.length > 0) glob.slot.prop.conflitto = true;
			return conflitti;
		},
		conflitto : () => { return !! glob.slot.prop.conflitto }
	};

	if ( typeof glob.prop.lastUsedEmail === 'undefined' ) {
		const ls = window.localStorage;
		const ss = (window.matchMedia('(display-mode: standalone)').matches) ? window.localStorage : window.sessionStorage;
		if ( ls && ss ) {
			glob.storage = { local: ls, session: ss };
			if ( ls.getItem('prenotazioniLastEmail') ) {
				glob.prop.status.lastUsedEmail = ls.getItem('prenotazioniLastEmail');
			}
			if ( glob.prop.status.lastUsedEmail && ss.getItem('prenotazioniSession')) {
				setTimeout( ()=>{ glob.loginSucceded( glob.prop.status.lastUsedEmail, ss.getItem('prenotazioniSession')) }, 500);
			} else if ( typeof glob.prop.loggedIn === 'undefined' ) {
				setTimeout( glob.logoutSucceded, 500);
			}
		}
	}

	// Code to handle install prompt on desktop
	window.addEventListener('beforeinstallprompt', (e) => {
		e.preventDefault();
		if ( window.sessionStorage.getItem('AthsRefused') ) return;
		window.deferredAthsPrompt = e;
		glob.trigger('deferredAthsPrompt',window.deferredAthsPrompt);
	});

	window.glob = glob;
}
